export default "__VITE_ASSET__BCeuzr5I__"